import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { userManagementBaseUrl, userManagement } from "../endpoints";

export const inventoryItemMasterService = createApi({
  reducerPath: "inventoryItemMasterService",
  baseQuery: fetchBaseQuery({ baseUrl: userManagementBaseUrl }),
  tagTypes: ["inventoryItemMaster"],
  endpoints: (builder) => ({
    // ✅ Get All with Pagination
    getAllInventoryItemMaster: builder.mutation({
      query: (body) => ({
        url: `${userManagement.inventoryItemMasterController.getAllInventoryItemMasterWithPagination}/${body.payload.page}/${body.payload.size}?orderBy=${body.payload.orderBy}`,
        method: "GET",
        headers: { Authorization: `Bearer ${body.token}` },
      }),
    }),

    // ✅ Search
    searchInventoryItemMaster: builder.mutation({
      query: (body) => ({
        url: `${userManagement.inventoryItemMasterController.searchInventoryItemMaster}`,
        method: "POST",
        body: body.payload,
        headers: { Authorization: `Bearer ${body.token}` },
      }),
    }),

    // ✅ Save
    saveInventoryItemMaster: builder.mutation({
      query: (body) => ({
        url: `${userManagement.inventoryItemMasterController.saveInventoryItemMaster}`,
        method: "POST",
        body: body.payload,
        headers: { Authorization: `Bearer ${body.token}` },
      }),
    }),

    // ✅ Update
    updateInventoryItemMaster: builder.mutation({
      query: (body) => ({
        url: `${userManagement.inventoryItemMasterController.updateInventoryItemMaster}/${body.id}`,
        method: "PUT",
        body: body.payload,
        headers: { Authorization: `Bearer ${body.token}` },
      }),
    }),

    // ✅ Delete
    deleteInventoryItemMaster: builder.mutation({
      query: (body) => ({
        url: `${userManagement.inventoryItemMasterController.deleteInventoryItemMaster}/${body.id}`,
        method: "DELETE",
        headers: { Authorization: `Bearer ${body.token}` },
      }),
    }),

    // ✅ Get by ID
    getInventoryItemMasterById: builder.mutation({
      query: (body) => ({
        url: `${userManagement.inventoryItemMasterController.getInventoryItemMasterById}/${body.id}`,
        method: "GET",
        headers: { Authorization: `Bearer ${body.token}` },
      }),
    }),

    // ✅ Get All without pagination
    findAllInventoryItemMaster: builder.mutation({
      query: (body) => ({
        url: `${userManagement.inventoryItemMasterController.getAllInventoryItemMaster}`,
        method: "GET",
        headers: { Authorization: `Bearer ${body.token}` },
      }),
    }),

    // ✅ Bulk Upload
    bulkUploadInventoryItemMaster: builder.mutation({
      query: (body) => {
        return {
          url: `${userManagement.inventoryItemMasterController.bulkUploadInventoryItemMaster}`,
          method: "POST",
          body: body.payload,
          headers: { Authorization: `Bearer ${body.token}` },
        };
      },
    }),
  }),
});

export const {
  useGetAllInventoryItemMasterMutation,
  useSearchInventoryItemMasterMutation,
  useSaveInventoryItemMasterMutation,
  useUpdateInventoryItemMasterMutation,
  useDeleteInventoryItemMasterMutation,
  useGetInventoryItemMasterByIdMutation,
  useFindAllInventoryItemMasterMutation,
  useBulkUploadInventoryItemMasterMutation,
} = inventoryItemMasterService;
